import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { Modal, ELEVATED_MODAL_Z_INDEX } from './Modal';

interface Props {
    isOpen: boolean;
    onLogout: () => void;
}

export const TeamUpdatedModal: React.FC<Props> = ({ isOpen, onLogout }) => {
    const theme = useTheme();

    return (
        <Modal
            isOpen={isOpen}
            onClose={onLogout}
            title="Team Updated"
            showCloseButton={false}
            // Mounted at the app root and not dismissible except via the button below -- must
            // always paint above an ordinary case-level modal, not just whichever mounted later.
            zIndex={ELEVATED_MODAL_Z_INDEX}
        >
            <div style={{ padding: theme.spacing.lg, maxWidth: '420px' }}>
                <p style={{ margin: 0, marginBottom: theme.spacing.lg, fontSize: theme.typography.fontSize.md, color: theme.colors.text.primary, lineHeight: 1.6 }}>
                    Your team has been updated. To make sure you have access to the appropriate
                    features, you will need to login again. If you were in the middle of an edit,
                    please check that it saved before continuing.
                </p>
                <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                    <button
                        onClick={onLogout}
                        style={{
                            padding: `${theme.spacing.sm} ${theme.spacing.lg}`,
                            backgroundColor: theme.colors.primary,
                            color: theme.colors.text.inverse,
                            border: 'none',
                            borderRadius: theme.borderRadius.md,
                            fontSize: theme.typography.fontSize.sm,
                            fontWeight: theme.typography.fontWeight.medium,
                            cursor: 'pointer',
                        }}
                    >
                        OK
                    </button>
                </div>
            </div>
        </Modal>
    );
};
